import React from 'react';
import { motion } from 'framer-motion';
import { InboxIcon, KanbanSquareIcon, CalendarIcon, StarIcon, UsersIcon, PhoneMissedIcon, MessageCircleIcon } from 'lucide-react';
const columns = [{
  title: 'New Lead',
  cards: [{
    name: 'Kitchen Remodel',
    who: 'J. Rivera',
    tag: 'Web Form'
  }, {
    name: 'Botox Consult',
    who: 'A. Kim',
    tag: 'Missed Call'
  }]
}, {
  title: 'Contacted',
  cards: [{
    name: 'AC Tune-Up',
    who: 'M. Brooks',
    tag: 'Chat'
  }]
}, {
  title: 'Estimate Sent',
  cards: [{
    name: 'Roof Repair',
    who: 'D. Patel',
    tag: 'Google Ad'
  }]
}, {
  title: 'Won',
  cards: [{
    name: 'Teeth Whitening',
    who: 'S. Lopez',
    tag: 'Paid'
  }]
}];
const messages = [{
  icon: PhoneMissedIcon,
  who: 'A. Kim',
  text: 'Auto-text sent: “Sorry we missed you!”',
  time: '1m'
}, {
  icon: MessageCircleIcon,
  who: 'M. Brooks',
  text: 'Can you come Thursday?',
  time: '6m'
}, {
  icon: StarIcon,
  who: 'S. Lopez',
  text: 'Left a 5-star review',
  time: '12m'
}];
export function DashboardMockup() {
  return <div className="relative" aria-hidden="true" data-id="element-158" data-mp="3etloov6k3rcw">
      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl" data-id="element-159" data-mp="3euwxj9euzpav">
        <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3" data-id="element-160" data-mp="3itxboeme63rj">
          <div className="flex items-center gap-1.5" data-id="element-161" data-mp="3530url1tvb0b">
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-162" data-mp="3a2wx7fuvmudr" />
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-163" data-mp="3a0slwcunet3g" />
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-164" data-mp="2v4uwddf8cn07" />
          </div>
          <span className="flex items-baseline gap-1 whitespace-nowrap" data-id="element-165" data-mp="305sanex4cwwf">
            <span className="text-xs font-bold text-brand-black" data-id="element-166" data-mp="2m57s8jv4933g">
              1Dash<span className="text-brand-red" data-id="element-167" data-mp="2m7arzvm2mald">.Pro</span>
            </span>
            <span className="text-[10px] font-medium text-brand-gray" data-id="element-168" data-mp="2r4kn9rw55gh4">— Powered by HighLevel</span>
          </span>
          <span className="w-10" data-id="element-169" data-mp="kbi8vrmln2z3" />
        </div>

        <div className="flex" data-id="element-170" data-mp="pcxuplwlpdij">
          <div className="hidden w-12 flex-col items-center gap-4 border-r border-gray-100 py-4 sm:flex" data-id="element-171" data-mp="pc60ofinjnud">
            {[KanbanSquareIcon, InboxIcon, CalendarIcon, UsersIcon, StarIcon].map((Icon, i) => <span key={i} className={`flex h-8 w-8 items-center justify-center rounded-md ${i === 0 ? 'bg-brand-red text-white' : 'text-brand-gray'}`} data-id="element-172" data-mp="iv4ewtitflsg" data-mpi={i}>
                <Icon className="h-4 w-4" data-id="element-173" data-mp="8yrrgddv6465" />
              </span>)}
          </div>

          <div className="flex-1 bg-gray-50 p-3 sm:p-4" data-id="element-174" data-mp="16mi78zgyvhdf">
            <p className="mb-3 text-xs font-bold text-brand-black" data-id="element-175" data-mp="16o32krb3v4cc">Sales Pipeline</p>
            <div className="grid grid-cols-4 gap-2" data-id="element-176" data-mp="11nfby6qsgpin">
              {columns.map(col => <div key={col.title} className="min-w-0" data-id="element-177" data-mp="wumbhv2cs3cd">
                  <p className="mb-2 truncate text-[10px] font-semibold text-brand-gray" data-id="element-178" data-mp="rxm51j1lcykq">{col.title}</p>
                  <div className="space-y-2" data-id="element-179" data-mp="1pczvaqqutosg">
                    {col.cards.map(card => <div key={card.name} className="rounded-md border border-gray-200 bg-white p-2 shadow-sm" data-id="element-180" data-mp="1kl9j0f8cwqye">
                        <p className="truncate text-[11px] font-bold text-brand-black" data-id="element-181" data-mp="1rxzd0jcuh50n">{card.name}</p>
                        <p className="truncate text-[10px] text-brand-gray" data-id="element-182" data-mp="1wx25737q7gr7">{card.who}</p>
                        <span className={`mt-1.5 inline-block rounded px-1.5 py-0.5 text-[9px] font-semibold ${card.tag === 'Paid' ? 'bg-brand-red text-white' : 'bg-brand-light text-brand-black'}`} data-id="element-183" data-mp="21uu80s9wsna6">
                          {card.tag}
                        </span>
                      </div>)}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative -mt-10 ml-auto mr-4 w-[78%] rounded-xl border border-gray-200 bg-white p-3 shadow-xl sm:absolute sm:-bottom-10 sm:-left-8 sm:mr-0 sm:mt-0 sm:w-72" data-id="element-184" data-mp="2pjwmjr98y00g">
        <div className="mb-2 flex items-center gap-2" data-id="element-185" data-mp="3rbxwyj7qjjv5">
          <InboxIcon className="h-4 w-4 text-brand-red" data-id="element-186" data-mp="3r9bpskorb6dg" />
          <p className="text-xs font-bold text-brand-black" data-id="element-187" data-mp="8vvgqgk7e4ty">One Inbox</p>
        </div>
        <ul className="divide-y divide-gray-100" data-id="element-188" data-mp="4vbmbkr0lfbi">
          {messages.map(m => <li key={m.who} className="flex items-center gap-2.5 py-2" data-id="element-189" data-mp="3dav9q35083in">
              <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-brand-tint text-brand-red" data-id="element-190" data-mp="38ca7jy66z9rk">
                <m.icon className="h-3.5 w-3.5" data-id="element-191" data-mp="3mcbjq9rwq3mc" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-192" data-mp="3hcylytzhzc4z">
                <span className="block text-[11px] font-bold text-brand-black" data-id="element-193" data-mp="3hc72ghj6d4v2">{m.who}</span>
                <span className="block truncate text-[10px] text-brand-gray" data-id="element-194" data-mp="11kt06n05i7oa">{m.text}</span>
              </span>
              <span className="text-[10px] text-brand-gray" data-id="element-195" data-mp="wm7wueplr7vm">{m.time}</span>
            </li>)}
        </ul>
      </motion.div>
    </div>;
}